import { render } from "./MoneyBand.vue?vue&type=template&id=a2223c36&scoped=true"
import script from "./MoneyBand.vue?vue&type=script&lang=js"
export * from "./MoneyBand.vue?vue&type=script&lang=js"

import "./MoneyBand.vue?vue&type=style&index=0&id=a2223c36&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2223c36"]])

export default __exports__